import { useState } from 'react'
import Header from '../components/header'
import Footer from '../components/footer'
import WordCount from '../components/subCmponents/wordCount'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCopy, faTicket, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from 'react-helmet'

export default function Counter() {

    let [word, setWord] = useState(0);
    let [character, setCharacter] = useState(0);
    let [noSpaces, setNoSpaces] = useState(0);
    let [sentence, setSentence] = useState(0);
    let [paragraph, setParagraph] = useState(0);
    let [input, setInput] = useState("");

    let checkInput = (e) => {
        const text = e.target.value;
        setInput(text);

        // Characters (with and without spaces)
        setCharacter(text.length);
        setNoSpaces(text.replace(/\s/g, "").length);

        // Words (robust split by spaces, tabs, newlines)
        const wordArray = text.trim().split(/\s+/).filter(Boolean);
        setWord(wordArray.length);

        // Sentences (split by punctuation followed by space or end of line)
        const sentenceMatches = text.match(/[^.!?]+[.!?]+(\s|$)/g);
        setSentence(sentenceMatches ? sentenceMatches.length : 0);

        // Paragraphs (split by double line breaks or line breaks with non-empty lines)
        const paragraphs = text.split(/\n+/).filter(p => p.trim() !== "");
        setParagraph(paragraphs.length);
    }
    let clearText = () => {
        setInput(input = "");
        setWord(word = 0);
        setParagraph(paragraph = 0);
        setCharacter(character = 0);
        setNoSpaces(noSpaces = 0);
        setSentence(sentence = 0);
    }

    let [copy, setCopy] = useState(false);
    let copyText = async () => {
        setCopy(copy = true);
        navigator.clipboard.writeText(input);
        setTimeout(() => {
            setCopy(copy = false);
        }, 2000);
    }

    return (
        <div className="counter">
            <Helmet>
                <html lang="en" />
                <title>Word Counter</title>
                <meta
                    name="description"
                    content="Free online word counter and character counter tool. Count words, characters, sentences, and paragraphs instantly."
                />
                <link rel="canonical" href="https://tooliso.com/Counter" />

                <meta property="og:title" content="Word Counter – Free Online Tool" />
                <meta
                    property="og:description"
                    content="Count words and characters instantly using Tooliso's free online word counter. No signup, fast results."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://tooliso.com/Counter" />

                <meta name="twitter:card" content="summary" />
                <meta name="twitter:title" content="Tooliso Word Counter – Free and Fast" />
                <meta
                    name="twitter:description"
                    content="Use Tooliso’s Word Counter to quickly count words, characters, sentences, and more online."
                />
            </Helmet>

            <Header />

            <div className="innerCounter">
                <div className="paracounter">
                    <h1>Word & Character Counter</h1>
                    <p>Count words, characters, sentences, and paragraphs in real-time</p>
                </div>
                <div className="inputCounter">
                    <textarea type="text" placeholder='Type or paste your text here...' value={input} onChange={(e) => checkInput(e)}></textarea>
                    <div className="borderCounter">
                        <WordCount icon="WholeWord" value={word} name="Word" />
                        <WordCount icon="BookA" value={character} name="Characters" />
                        <WordCount icon="Keyboard" value={noSpaces} name="Characters (no spaces)" />
                        <WordCount icon="AlignLeft" value={paragraph} name="Paragraphs" />
                        <WordCount icon="BookOpen" value={sentence} name="Sentences" />
                    </div>
                    <div className="copyCounter">
                        <button className='clearBtn' onClick={clearText}><FontAwesomeIcon icon={faTrash} />Clear Text</button>
                        {
                            copy ?
                                <button className='copyBtn'><FontAwesomeIcon icon={faCheck} />Text Copied</button>
                                :
                                <button className='copyBtn' onClick={copyText}><FontAwesomeIcon icon={faCopy} />Copy Text</button>
                        }
                    </div>
                </div>
                <div className="aboutWord">
                    <h1>About Word Counter Tool</h1>
                    <p>Tooliso's Word Counter is a free online tool that instantly counts words, characters (with and without spaces), sentences, and paragraphs in your text. It's perfect for writers, students, SEO specialists, and anyone who needs to analyze their text content.</p>
                    <h3>How to use this word counter?</h3>
                    <ol>
                        <li><p>Type or paste your text into the text area above</p></li>
                        <li><p>The tool will automatically count words, characters, sentences, and paragraphs</p></li>
                        <li><p>Use the "Clear" button to reset the counter</p></li>
                        <li><p>Use the "Copy" button to copy your text to clipboard </p>               </li>
                    </ol>
                    <h2>Who needs a word counter?</h2>
                    <ul className='ollist'>
                        <li><h3>Writers & Bloggers:</h3><p> Check article length and word count requirements.</p></li>
                        <li><h3>Students:</h3><p>Meet essay or assignment length requirements.</p></li>
                        <li><h3>SEO Specialists:</h3><p>Optimize meta descriptions and content length.</p></li>
                        <li><h3>Social Media Managers:</h3><p>Stay within character limits for posts.</p></li>
                        <li><h3>Translators:</h3><p>Estimate project size and pricing.</p></li>

                    </ul>

                </div>
            </div>


            <Footer />
        </div>
    )
}
